const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto text-lg">
      <div className="grid grid-cols-12">
        <div className="col-start-3 col-span-8">
          <h1 className="text-4xl font-bold">Privacy Policy</h1>
          <p className="my-6">
            This is the Yantra Group Private Limited's Privacy Policy, with the
            registered address of Balkhu-14, Kathmandu, Nepal ("Yantra Group",
            "us", "we" or "our"). It explains how we, as data controllers,
            collect, use, and share information about you (including personal
            information) through our app "Yantra," which you can use to book
            services and purchase related goods ("Products") (collectively
            referred to as "the Services"), and through other interactions with
            us that you may have during the course of our various marketing and
            other activities. It also describes your rights as a user of our
            Services to regulate how your data is used. Any information about a
            natural person that permits that person to be identified directly or
            indirectly from that information is considered personal information.
            Users of the Services on whose behalf service bookings are made or
            Products are purchased are referred to as "Users" in this Policy,
            while users of the Services on whose behalf we offer services are
            referred to as "Service Providers."
          </p>
          <h1 className="my-12 font-bold">
            Please read this Privacy Policy carefully before you start using the
            App.
          </h1>
          <h1 className="my-4 font-bold">Other applicable terms</h1>
          <p className="my-4">
            In addition to this Privacy Policy, our Terms of Use also apply to
            your use of the Services and are, where relevant, incorporated by
            reference into this Privacy Policy.
          </p>
          <ul className="list-disc">
            <li className="mt-4 mx-4 italic">
              Information we collect about you
            </li>
          </ul>
          <p className="my-2">
            Our primary goals in collecting information are to provide our
            Services to our Users and Service Providers, to better respond to
            their requests for help or information, to improve our Services and
            their features and content, and to promote our Services through our
            app, events, newsletters, competitions, and promotions where we have
            your permission to do so.
          </p>
          {/* First Section */}
          <h2 className="mt-12 font-bold">
            1. Categories of Information we collect from you:
          </h2>
          <h3 className="mt-6 font-bold">
            Relating to both Users and Service Provide:
          </h3>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Identity data
            </span>{" "}
            - information used to identify users including first name, last
            name, title, date of birth, gender, log in and User and Service
            Provider password details
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Contact data
            </span>{" "}
            - postal address, email address, telephone number and mobile number
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Financial data
            </span>{" "}
            - bank accounts of Service Provider in order to pay them for the
            Services and payment card details to manage payment for services by
            Users on behalf of the Service Provider and purchases of Products on
            behalf of Retailers, we note we do not collect full card details but
            work with third party payment providers (see below) to processor the
            payment.
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Technical data
            </span>{" "}
            - internet protocol (IP) address, log in (password), browser type
            and version, time zone setting and location, browser plug-in types
            and versions, operating system and platform and other technology on
            the devices used by the user to access your website or app.
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Marketing and communications data
            </span>{" "}
            - User and Service Provider preferences in receiving marketing from
            Yantra Group and any third party affiliates.
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Operational data
            </span>{" "}
            - including interaction with the Services and transcripts from
            calls, messages from "live chats" with both Users and Service
            Provider,
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Location data
            </span>{" "}
            - data that is used to enable the Service Provider to find the User
            in order to perform the treatment and the User to check the arrival
            of the Service Provider
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Aggregated data
            </span>{" "}
            - data that is collected, used and shared such as statistical or
            demographic data for any purpose, eg. used to analyse trends, track
            Users' movements around the app and to gather information on our
            User base as a whole. Or, in the case of Service Provider we may
            collect data such as number of bookings and schedule information
          </p>
          <h3 className="mt-8 font-bold">Relating to Users only:</h3>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Transaction data
            </span>{" "}
            - contains information about the products and services that users
            have purchased through the app. Usage data is data on how users
            interact with the Services. This includes how you interact with the
            Services, such as how long you communicate with Yantra Group at a
            given time or how frequently you make a booking and the areas of the
            Services with which you engage, as well as the features that you
            utilize.
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Profile data
            </span>{" "}
            - includes User website browsing history, demographic information
            such as age, gender, education level, feedback and survey responses,
            any information that you have made publicly available on our
            noticeboards or on social media networks
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Work related data
            </span>{" "}
            - We collaborate with companies to provide our services to their
            employees. If you work for one of those companies, you must register
            with us in order to access the Services. When you do this, we will
            immediately gather information from you.
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Service Notes
            </span>
            - we may collect information about our Service delivery for example,
            instructions on how to access a building. You provide this
            information voluntarily. We pass this information on to Service
            Provider so that they can understand any specific access / similar
            requirements.
          </p>
          <h3 className="mt-8 font-bold">Relating to Service Provider only:</h3>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Assessment data
            </span>{" "}
            - information on qualifications and certification of Service
            Provider, trade test assessment results, contact logs data,
            performance and ratings data
          </p>
          <p className="my-2">
            <span className="underline underline-offset-2 font-bold">
              Profile data
            </span>{" "}
            - Photograph, biography, treatments offered and languages spoken by
            Service Provider and average rating obtained from our evaluation
            using algorithms of ratings review and feedback survey results,
            number of bookings and schedule information.
          </p>
          <ul className="list-disc">
            <li className="mt-8 mx-4 italic">
              Information we collect about you
            </li>
          </ul>
          <p className="my-2">
            This information will be used to run the Services as well as for
            internal operations such as troubleshooting, data analysis, testing
            research, and statistical surveys. This information will also be
            used to assess the efficacy of how we provide content and offer our
            services, as well as how we sell and advertise. When you choose to
            participate in the interactive elements of our Services, this
            information will be utilized to enable you to do so. You always have
            the option of providing or withholding information. You may not be
            able to utilize certain features of the app or receive certain
            Services if you do not supply certain information.
          </p>
          <ul className="list-disc">
            <li className="mt-8 mx-4 italic">
              Information we may collect from other sources or which is
              automatically collected
            </li>
          </ul>
          <p className="my-2">
            Our affiliates and third-party sources, such as our third-party
            service providers (such as events, marketing services, and payment
            providers), publically accessible data, other firms, and referrals,
            may be used to collect information.
          </p>
          <p className="my-2">
            We may collect personal information from time to time from publicly
            available sources, such as LinkedIn, or from a publicly available
            online registry to which you provide your information, or from your
            company's website, in order to contact you in our legitimate
            business interests with business opportunities that we believe
            require your participation. In our first correspondence with you,
            we'll let you know whether we got your information from a
            third-party source for these objectives.
          </p>
          {/* Second Section */}
          <h2 className="mt-12 font-bold">2. Uses made of your information</h2>
          <p className="my-2">
            We will use the personal information described above to:
          </p>
          <ol className="my-2 ml-12 list-alphal">
            <li className="mb-2">
              Identify Users and Service Provider when they sign in to their
              account;
            </li>
            <li className="mb-2">
              Enable us to process Users' bookings of Services on behalf of
              Service Provider and purchases of Products on behalf of Retailers,
              send confirmation of Service bookings or confirmation of
              cancellations of bookings, and to enable Users and Service
              Provider to access other information or assistance offered through
              the Services and which they request including but not limited to
              customer service requests or assistance with dispute resolution;
            </li>
            <li className="mb-2">
              Administer User and Service Provider accounts;
            </li>
            <li className="mb-2">
              To assess and verify qualifications and credentials of Service
              Provider and to create and maintain profiles of Service Provider;
            </li>
            <li className="mb-2">
              To manage and process the collection of payment of behalf of
              Service Provider for Services booked by Users and collection of
              payment on behalf of Retailers for Products purchased by Users;
            </li>
            <li className="mb-2">
              Analyse the use of the Services and the visits to the App in order
              to improve our content and Services including research into our
              Users’ demographics and tracking of sales data;
            </li>
            <li className="mb-2">
              Where you have not objected, send you information to Users and
              Service Provider which we think you may find useful or which you
              have requested from us, including marketing communications such as
              emails about any improvements to the Products or Services, special
              offers or promotions, events, competitions, new Products or
              Services;
            </li>
            <li className="mb-2">
              Where you have not objected, send you, information about any
              improvements to existing products or services, special offers or
              promotions, events or competitions, new products or services of
              carefully selected Business Partners. Yantra Group does not share
              any personal data of its Users or Service Provider with any
              Business Partners but you may see our Business Partners name,
              logos and other brand references appearing in the emails which we
              send to you
            </li>
          </ol>
          <p className="my-4">
            For fraud protection, risk assessment, regulatory compliance,
            investigation, product development, research, analytics, and
            customer support purposes, we may review, scan, or analyze your
            communications on the Yantra Platform between the User and the
            Service provider. We may also scan, evaluate, or analyze messages to
            debug, improve, or expand product offerings in specific situations.
            Wherever possible, we use automated approaches. However, we may need
            to analyze some communications manually on occasion, such as for
            fraud investigations and customer service, or to assess and improve
            the functionality of these automated systems. We will not examine,
            scan, or analyze your messaging communications in order to send you
            third-party marketing messages, and we will not sell these
            communications' reviews or analyses. Yantra's legitimate interests
            in ensuring compliance with applicable laws and our Terms,
            preventing fraud, promoting safety, and enhancing and assuring the
            adequate performance of our services are the basis for these
            operations.
          </p>
          {/* Section Three */}
          <h2 className="mt-12 font-bold">
            3. Purposes and Lawful Bases for which Yantra Group uses your data
          </h2>
          <p className="my-2">
            We have set out in the tables below a description of the ways we use
            your personal information, the category of information it comes
            under and the legal basis or bases which we rely on to process it,
            including where we are relying on our legitimate interests and
            identifying what those interests are. There may be more than one
            lawful basis on which we process your information depending on the
            specific purposes for which we are using the information. Where we
            rely on legitimate interests we are always careful to balance your
            privacy rights with those interests.
          </p>
          <p className="my-8">
            Please note that these are examples of the kinds of personal
            information we collect and of the uses we may make of it. We may
            from time to time collect other types of personal information
            including and not limited to information you voluntarily give us.
          </p>
          <p className="my-8">
            Please contact us if you need more information at{" "}
            <span className="font-bold">info@yantragroup.com.np</span>
          </p>
          <h3 className="mt-8 font-bold">User Information</h3>
          <table className="my-4 table-auto border-collapse border border-solidborder-slate-400">
            <colgroup>
              <col width="35%" />
              <col width="30%" />
              <col width="35%" />
            </colgroup>
            <thead>
              <tr>
                <th className="border-collapse border border-solid border-slate-300 p-4 text-left">
                  Purpose
                </th>
                <th className="border-collapse border border-solid border-slate-300 p-4 text-left">
                  Type of data
                </th>
                <th className="border-collapse border border-solid border-slate-300 p-4 text-left">
                  Lawful basis for processing
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To register a new User
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, technical
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for us to perform our contract with you; it is in
                  our legitimate interests in operating our Services to analyze
                  how they are utilized and improve them.
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To identify you as a User when you sign in to your account
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, Technical data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of our contract with you; in our
                  legitimate interests in operating our Services to analyse how
                  our Services are being used and develop these further.
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To process and deliver a service request from a User
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, profile data, assessment data, location
                  data, technical data, transaction data, operational data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of our contract with you; in our
                  legitimate interests in operating our Services to analyse how
                  our Services are being used and develop these further.
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Managing collection of payment for Services booked by Users on
                  behalf of Service Provider or Products purchased by Users on
                  behalf of Retailers
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, financial data, transaction data,
                  operational data{" "}
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for performance of the contract with Users, Service
                  Provider and Retailers
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Assisting Users with queries and problems in live chats on app
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Technical data, operational data, identity, contact{" "}
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of the contract with our Users;,
                  in our legitimate interests to resolve problems to ensure our
                  Services run as smoothly as possible to increase User
                  satisfaction
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To administer and protect the app and Services (including
                  troubleshooting, data analysis, testing and system review)
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, technical data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In our legitimate interests to run our app and services,
                  manage administration and IT services and safeguard network
                  security
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To manage our relationship with Users by sending emails to
                  confirm bookings for Services or cancellations of bookings or
                  Products purchased
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, technical data, transaction data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of a contract with the User; in
                  our legitimate interests in maintaining and improving the
                  running of the Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Asking Users to complete ratings reviews and feedback surveys
                  on Service provider and treatments received
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, usage, profile data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In our legitimate interests to understand how Users use, enjoy
                  and rate the Services to ensure Service standards are
                  maintained
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Inviting Users to take part in any promotions, events or
                  competitions
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, usage data, marketing and communications
                  data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  With consent where required by law in or where Users have not
                  objected; in the legitimate interests of the business to
                  encourage Users to use the Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To make recommendations and suggestions to Users
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact data, usage data, profile data, marketing
                  and communications data, aggregated data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In the legitimate interests of the business to develop and
                  grow{" "}
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To advertise and market our app and services to Users
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Usage data, marketing and communications data, aggregated data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  With consent where required by law in or where Users have not
                  objected the case of direct marketing email communications ;in
                  the case of analysis and evaluation of our Services and
                  campaigns in the legitimate interests of the business to
                  develop and grow
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To send Users information about products or services, special
                  offers or promotions, events or competitions of carefully
                  selected Business Partners.
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, usage, profile, marketing and
                  communications, aggregated data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  With consent as required by law, in the legitimate interests
                  of the business to encourage Users to use our Business
                  Partners' Products and Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To notify Users about any changes to our app and /or Products
                  and/or Services
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity data, contact data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of a contract with the User and
                  in the legitimate interests of the business in the smooth
                  running of the Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To notify Users of any changes to the Privacy Policy or
                  changes to our Terms and Conditions
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity data, contact data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Compliance with a legal obligation
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To maintain a blacklist/fraud identity system
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity data, contact data, financial data,
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In the legitimate interests of the business to protect the
                  business from fraud
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To record Service Notes which are used to provide information
                  to Service Provider to deliver treatments
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Information provided by users which may include access
                  information
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In our legitimate interests to provide Services that are as
                  efficient and smooth running as possible. This information is
                  provided voluntarily.
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To gather location data on Users in order to inform the
                  Service Provider of the location in which to perform the
                  treatment
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity data, contact data, Location data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary to fulfil the contract for services for the User, in
                  our legitimate interests to provide Services that are as
                  efficient and smooth running as possible. If this is collected
                  automatically through your device, you will be asked if you
                  permit us access to your location. We need your location in
                  order to inform the Service Provider where the treatment needs
                  to be performed.
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To provide mediation between User and Service Provider in the
                  event of a User complaint of unsatisfactory treatment
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, assessment, financial data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary to fulfil the contract for services for the User, in
                  our legitimate interests to provide Services
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className="mt-8 font-bold">Service Provider Information</h3>
          <table className="my-4 table-auto border-collapse border border-solidborder-slate-400">
            <colgroup>
              <col width="35%" />
              <col width="30%" />
              <col width="35%" />
            </colgroup>
            <thead>
              <tr>
                <th className="border-collapse border border-solid border-slate-300 p-4 text-left">
                  Purpose
                </th>
                <th className="border-collapse border border-solid border-slate-300 p-4 text-left">
                  Type of data
                </th>
                <th className="border-collapse border border-solid border-slate-300 p-4 text-left">
                  Lawful basis for processing
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To register a new Service Provider
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, technical
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of our contract with Service
                  Provider, in our legitimate interests in operating our
                  Services{" "}
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To identify a Service Provider when they sign in to their
                  account{" "}
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, Technical data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of our contract with the Service
                  Provider
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To assign and transmit a transmit a Service booking to the
                  appropriate Service Provider (according to location and/or
                  profile, rating or User choice)
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, profile data, assessment data, location
                  data, technical data, transaction data, operational data{" "}
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of the User contract, fulfilling
                  our contract with the Service Provider by sending appropriate
                  bookings{" "}
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Managing collection of payment by Users for Services on behalf
                  of Service Provider and management of transfer of payments to
                  Service Provider
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, financial data, transaction data,
                  operational data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for performance of our contract with both Service
                  Provider and User, (obligation to process payment by User and
                  obligation to collect payment on behalf of the Service
                  Provider for Services booked by User.
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Assisting Service Provider with queries and problems in live
                  chats on app
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, Technical data, operational data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of the contract with Service
                  Provider, in our legitimate interests to resolve problems to
                  ensure the Services run as smoothly as possible to increase
                  User satisfaction
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To administer and protect the app and Services (including
                  troubleshooting, data analysis, testing and system review){" "}
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, technical data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In our legitimate interests to run our app and Services,
                  manage administration and IT services and ensure network
                  safety and security
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To manage our relationship with Service Provider by sending
                  confirmatory emails of bookings or cancellations with Users{" "}
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, technical data, transaction data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of a contract with the User,
                  necessary for the fulfilment of a contract with the Service
                  Provider, in our legitimate interests in maintaining and
                  improving the running of the Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To maintain profiles on Service Provider including
                  photograph(s), biography, treatments offered, languages
                  spoken.
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, assessment, profile data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of a contract with the Service
                  Provider and User, in our legitimate interests in maintaining
                  and improving the running of the Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To review Service Provider use of the App and User experience
                  with the Service Provider. For example, we may analyse average
                  ratings obtained from our evaluations, using algorithms
                  applied to ratings and reviews. We take all of the ratings you
                  have received from your past appointments with customers,
                  apply a weighted rating upon them, and use this to display
                  both in your profile and as part of the sorting algorithm when
                  returning a list of Service Provider available to customers
                  when they are searching/booking.{" "}
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Number of appointments, User rating review
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In our legitimate interests in maintaining and improving the
                  quality and the running of the Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Providing Service Provider with feedback from Users including
                  results of ratings reviews and feedback surveys
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Providing Service Provider with feedback from Users including
                  results of ratings reviews and feedback surveysIdentity,
                  contact, assessment, profile data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of a contract with the Service
                  Provider, in our legitimate interests in maintaining and
                  improving the running of the Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Inviting Service Provider to take part in any promotions,
                  events or competitions
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, usage data, marketing and communications
                  data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  With consent as required by law, In the legitimate interests
                  of the business to encourage Service Provider to use the
                  Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To advertise and market our app and Services
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, Usage, marketing and communications,
                  aggregated data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  With consent as required by law, in the legitimate interests
                  of the business to develop and grow
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To send Service Provider' information about products or
                  services, special offers or promotions, events or competitions
                  of carefully selected Business Partners.
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, usage, profile, marketing and
                  communications, aggregated data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  With consent as required by law, in the legitimate interests
                  of the business to encourage Service Provider to use our
                  Business Partners' Products and Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To notify Service Provider about any changes to our app and
                  /or Services
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary for the performance of contract with the Service
                  Provider and in the legitimate interests of the business to
                  ensure the smooth running of the Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To notify Service Provider of any changes to our Privacy
                  Policy or changes to our contract terms and conditions
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact data{" "}
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Compliance with a legal obligation
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To maintain a blacklist/fraud identity system
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  identity system Identity, contact, financial data,
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In the legitimate interests of the business to protect the
                  business from fraud
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To gather location data on Service Provider to share with
                  Users to inform them as to when the Service Provider may
                  arrive to deliver the Treatments
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity data, contact data, Location data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary to fulfil the contract for Services for the User, in
                  our legitimate interests to provide Services that are as
                  efficient and smooth running as possible
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To record Treat Reports if a User enables this feature, some
                  Service Provider personal data will be captured against this
                  Treatment report.
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary to fulfil the contract for Services for the User, in
                  our legitimate interests to provide Services that are as
                  efficient and smooth running as possible If this is collected
                  automatically through your device, you will be asked if you
                  permit us access to your location.
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To provide mediation between User and Service Provider in the
                  event of a User complaint of unsatisfactory treatment
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, assessment, financial data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Necessary to fulfil the contract for services for the User, in
                  our legitimate interests to provide Services
                </td>
              </tr>
              <tr>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  To monitor correct use by Service Provider of our proprietary
                  technology and Users' personal data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  Identity, contact, technical, usage data
                </td>
                <td className="border-collapse border border-solid border-slate-300 p-4 text-slate-600">
                  In our legitimate interests to monitor correct use of our
                  proprietary technology and Users' personal data and for
                  recordkeeping purposes
                </td>
              </tr>
            </tbody>
          </table>
          {/* Section Four */}
          <h2 className="mt-12 font-bold">
            4. How we may share your Information
          </h2>
          <p className="my-4">
            In order to provide the Services, we may share the information Users
            provide with Service Provider to assist them in the providing the
            Services booked by Users.
          </p>
          <p className="my-4">
            In order to provide the Services, we may share the information
            Service Provider provide to Users to assist them in selecting a
            Service Provider to book a Services with.
          </p>
          <p className="my-4">
            We may share the information you provide or that we otherwise
            collect through your use of the Services (including, where
            applicable, personal information) with carefully selected
            third-parties such as affiliates, consultants, and contractors who
            assist us with our business and operations, such as processing
            transactions, fulfilling requests for information or assistance,
            receiving and sending communications, analyzing data, and providing
            other support services such as e-mailing. These third parties will
            keep the information private and will only use it to perform the
            related service(s) or as otherwise permitted or required by law.
            Some examples of key service providers we work with include Google
            (cloud storage, analytics, and advertising services), and Facebook
            (marketing services).
          </p>
          <p className="my-4">
            In some cases, we work in partnership with other carefully selected
            companies, Business Partners, and from time to time, with your
            consent, we may send you information about these third-party
            Business Partners' selected products or services in our
            communications with you. We do not share your personal data with
            these third parties directly.
          </p>
          <p className="my-4">
            We may disclose aggregate statistics about visitors to the App in
            order to describe our services to prospective partners, advertisers,
            sponsors and other reputable third parties and for other lawful
            purposes.
          </p>
          <p className="my-4">
            In the event that we undergo re-organisation, or are sold to a third
            party, you agree that any personal information we hold about you may
            be transferred to that re-organised entity or third party.
          </p>
          <p className="my-4">
            We may disclose your personal information if legally entitled or
            required to do so (for example if required by law or by a court
            order or if we believe that such action is necessary to prevent
            fraud or cybercrime or to protect the App or Service, or the rights,
            property or personal safety of any person).
          </p>
          {/* Section Five */}
          <h2 className="mt-12 font-bold">
            5. Information you may collect as a User or Service Provider
          </h2>
          <p className="my-4">
            If you are a Service Provider, you are responsible for ensuring that
            you comply with applicable data protection law in respect of any
            personal information that you collect about Users in the course of
            your provision of the Services. Yantra Group does not accept any
            responsibility for this processing of personal data.
          </p>
          <p className="my-4">
            If you are a User, you are responsible for any misuse of personal
            information that you may collect in the course of your receipt of
            the Services. Yantra Group does not accept any responsibility for
            this processing of personal data.
          </p>
          {/* Section Six */}
          <h2 className="mt-12 font-bold">6. Public forums</h2>
          <p className="my-4">
            The App may, from time to time, make chat rooms, message boards,
            news groups and/or other public forums available to Users and
            Service Provider. Any information that is disclosed in these areas
            becomes public information and you should exercise caution when
            using these and never disclose your personal information.
          </p>
          {/* Section Seven */}
          <h2 className="mt-12 font-bold">7. Child safety</h2>
          <p className="my-4">
            Protecting the safety of children when they use the internet is very
            important to us. Our Services are not intended nor directed towards
            children and we do not knowingly collect personal information from
            children. If you believe that your child may have provided us with
            personal information without your consent, you may alert us at{" "}
            <span className="font-bold">info@yantragroup.com.np</span> .
          </p>
          {/* Section Eight */}
          <h2 className="mt-12 font-bold">8. External links</h2>
          <p className="my-4">
            The App may, from time to time, contain links to external websites.
            Clicking on those links or enabling those connections may allow
            third parties to collect or share information about you. We have no
            control over these third parties and we are not responsible for the
            content of such websites or for the privacy policies or practices of
            such third parties. You should review the privacy policy of any
            third party website carefully that you visit.
          </p>
          {/* Section Nine */}
          <h2 className="mt-12 font-bold">9. Payment processing</h2>
          <p className="my-4">
            All payments transactions made through the Services are conducted
            through our payment providers (Khalti) or through cash. You will be
            providing credit or debit card information directly to these
            providers who process payment details, encrypting your credit/debit
            card information and authorizing payment. If you use Khalti to
            process your payment, you will stay on our App but will provide your
            information directly to the payment providers, we only see a
            tokenized version of the information.
          </p>
          {/* Section Ten */}
          <h2 className="mt-12 font-bold">10. Security</h2>
          <p className="my-4">
            The security of all personal information associated with both Users
            and Service Providers is extremely important to us. We've put in
            place necessary technical and organizational safeguards to maintain
            the security of your data and to protect any personal information
            that's sent, stored, or otherwise processed from unintentional or
            unlawful destruction, loss, alteration, unauthorised disclosure, or
            access. Furthermore, only those employees, agents, contractors, and
            other third parties with a business need to know have access to this
            information. They will only process it according to our instructions
            and are bound by a strict code of secrecy.
          </p>
          <p className="my-4">
            The safety and security of your personal information also depends on
            you. Where you have a secure log in and or password for access to
            certain parts of our App, you are responsible for keeping your log
            in and/or password confidential. We ask you not to share your log in
            details or password with anyone. We also urge you to be careful
            about giving out information in public areas of the App like message
            boards. The information you share in public areas may be viewed by
            any user of the App or the Services.
          </p>
          <p className="my-4">
            Unfortunately, no electronic data transmission over the internet or
            storage of information can be guaranteed to be completely secure or
            error free and we therefore cannot warrant or guarantee the security
            of information you submit via the App or Service and any such
            submission is at your own risk.
          </p>
          {/* Section Eleven */}
          <h2 className="mt-12 font-bold">
            11. Data storage and international transfers
          </h2>
          <p className="my-4">
            Information that you submit via the Services is sent to and stored
            on secure servers located inside and outside the office where we
            transfer your information outside the office in this way, we will
            take steps to require that your privacy rights continue to be
            protected. By the way of example, and as mentioned above, we work
            with key service providers but not limited to such as Google,
            Facebook and we have signed data processing addendums which reflect
            data transfer mechanisms to provide adequate protection to the
            personal data transferred outside the office. If you would like
            further information on this, please do contact us.
          </p>
          {/* Section Twelve */}
          <h2 className="mt-12 font-bold">12. Opting out</h2>
          <p className="my-4">
            Where we have your consent, or where you have not objected to
            receiving (as applicable) we will use your personal information to
            send you marketing and promotional communications by email about our
            products/services or to send you feedback surveys and ratings review
            requests on treatments provided, you. As mentioned above, where we
            partner and work with carefully selected Business Partners, our
            email communications may also contain information from our Business
            Partners.
          </p>
          <p className="my-4">
            You can object to further marketing communications at any time by
            clicking on the unsubscribe link included in each such communication
            or notify us by email at{" "}
            <span className="font-bold">info@yantragroup.com.np</span>.
          </p>

          {/* Section Thirteen */}
          <h2 className="mt-12 font-bold">
            13. How long we keep your information
          </h2>
          <p className="my-4">
            In order for us to meet our contractual duties to you, we need to
            keep your information (including your personal information, where
            applicable) for as long as you are an active user of the Services,
            and for as long as is legally needed or authorized.
          </p>
          <p className="my-4">
            We may need to retain certain personal information even once a User
            account has been closed for differing periods, depending on the
            category of personal information concerned, for example, to enforce
            our terms, for fraud prevention, to identify, issue or resolve any
            legal claims, for proper record-keeping purposes and/or as required
            for our business operations or by applicable law.
          </p>
          <p className="my-4">
            We may also retain certain personal information following any
            objection indicated by you to receiving Yantra Group marketing
            communications for the purpose of ensuring that your wishes continue
            to be respected and we do not to contact you further.
          </p>
          <p className="my-4">
            We may also retain aggregated information beyond this time for
            research purposes and to help us to develop and improve Services.
            You cannot be identified from aggregate information retained or used
            for these purposes.
          </p>

          {/* Section Fourteen */}
          <h2 className="mt-12 font-bold">14. Your rights</h2>
          <p className="my-4">
            You have the right under certain circumstances:
          </p>
          <ol className="my-2 ml-12 list-disc">
            <li className="mb-2">
              To be provided with a copy of your personal information held by
              us;
            </li>
            <li className="mb-2">
              To request the rectification or erasure of your personal
              information held by us;
            </li>
            <li className="mb-2">
              To request that we cease processing your personal data in certain
              circumstances;
            </li>
            <li className="mb-2">
              To object to our processing of personal data for the purposes of
              sending you direct marketing emails;
            </li>
            <li className="mb-2">
              To request that we restrict the processing of your personal
              information while we verify or investigate your concerns;
            </li>
            <li className="mb-2">
              To request that your information be transferred to a third party;
            </li>
            <li className="mb-2">
              To withdraw consent where your personal information has been
              processed on this basis. You have the right to withdraw that
              consent without detriment by emailing us at
              info@yantragroup.com.np or by clicking on the unsubscribe link
              found at the bottom of our emails;
            </li>
          </ol>

          {/* Section Fifteen */}
          <h2 className="mt-12 font-bold">
            15. Changes to this Privacy Policy
          </h2>
          <p className="my-4">
            We may change this Privacy Policy from time to time. If a revision
            is material, we shall notify you before they take effect either
            through the App or by sending you a notification (as required). Any
            such material changes will only apply to personal information
            collected after the revised Privacy Policy takes effect.
          </p>

          {/* Section Sixteen */}
          <h2 className="mt-12 font-bold">16. Contact us</h2>
          <p className="my-4">
            Please submit any questions or concerns regarding our Privacy Policy
            or any questions about the security of our App or Services to:
          </p>
          <p className="my-4">
            <span className="font-bold">info@yantragroup.com.np</span>
          </p>

          <p className="my-12">
            This Privacy Policy was last updated on 21 February 2022
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
